import { doAction, doResponseAction } from ".";

const STUDENT_REPORT = 'STUDENT_REPORT';
const STUDENT_REPORT_SUCCESS = 'STUDENT_REPORT_SUCCESS';
const STUDENT_REPORT_FAILURE = 'STUDENT_REPORT_FAILURE';

const CLEAR_REPORTS="CLEAR_REPORTS"
export {
    STUDENT_REPORT,
    STUDENT_REPORT_SUCCESS,
    STUDENT_REPORT_FAILURE,
    CLEAR_REPORTS
}
export const clearStudentReports=data=>doAction(CLEAR_REPORTS,data)
export const studentReportAction = (params, callback) => doAction(STUDENT_REPORT, params, callback);
export const studentReportSuccessAction = data => doResponseAction(STUDENT_REPORT_SUCCESS, data);
export const studentReportFailureAction = data => doResponseAction(STUDENT_REPORT_FAILURE, data);

